import React from 'react';
import WorkspacePageAccess from './WorkspacePageAccess';

export default function WorkspaceNotificationSettings() {
  return <WorkspacePageAccess />;
}
